import { Component, computed, DestroyRef, inject, input, output, signal } from '@angular/core';
import { AppColor } from '../../../app';
import { LogLevel } from '../../../models/logger';
import { IconComponent } from '../../icon/icon.component';

const INTERVAL_TIME = 200; // in milliseconds

const DEFAULT = {
	title: 'Unknown',
	message: '',
	level: LogLevel.info,
	duration: 5000,
};

const LOG_LEVEL_DISPLAY: Record<LogLevel, { color: AppColor; icon: string }> = {
	[LogLevel.error]: { color: AppColor.ERROR, icon: 'error' },
	[LogLevel.warning]: { color: AppColor.WARNING, icon: 'error' },
	[LogLevel.success]: { color: AppColor.SUCCESS, icon: 'check_circle' },
	[LogLevel.info]: { color: AppColor.INFO, icon: 'info' },
	[LogLevel.debug]: { color: AppColor.GRAY_STRONG, icon: 'bug_report' },
};

@Component({
	selector: 'vis-toast-item',
	imports: [IconComponent],
	templateUrl: './toast-item.component.html',
	styleUrl: './toast-item.component.scss',
})
export class ToastItemComponent {
	public LogLevel = LogLevel;
	public LOG_LEVEL_DISPLAY = LOG_LEVEL_DISPLAY;

	public title = input(DEFAULT.title, {
		transform: (val: string | undefined) => val ?? DEFAULT.title,
	});
	public message = input(DEFAULT.message, {
		transform: (val: string | undefined) => val ?? DEFAULT.message,
	});
	public level = input(DEFAULT.level, {
		transform: (val: LogLevel | undefined) => val ?? DEFAULT.level,
	});
	public duration = input(DEFAULT.duration, {
		transform: (val: number | undefined) => val ?? DEFAULT.duration,
	});

	public timeIsUp = output<void>();

	public pause = signal(false);

	public display = computed(() => LOG_LEVEL_DISPLAY[this.level()]);

	constructor() {
		let elapsedTime = 0;
		let remainingTime = this.duration();

		const interval = setInterval(() => {
			if (this.pause()) return;
			elapsedTime += INTERVAL_TIME;
			remainingTime = this.duration() - elapsedTime;

			if (remainingTime < 0) {
				this.timeIsUp.emit();
				clearInterval(interval);
			}
		}, INTERVAL_TIME);

		inject(DestroyRef).onDestroy(() => clearInterval(interval));
	}
}
